import moment from "moment";
import ApiReturnJson from "../api/ApiReturnJson";
import * as EP from "./Api"; // EP stands for EndPoint
import { signOutUser } from "./ApiService";


// Report apis
export const fetchRootCauseReport = async (recipientId, eventTime, daysBack) => {
    try {
        const [response] = await Promise.all([
            ApiReturnJson("GET", `${EP.rootCauseReportEndpoint}/${recipientId}?eventTime=${eventTime.slice(0, 19)}&eventType=seizure&daysBack=${daysBack}`),
        ]);

        if (response.isSuccess) {
        return response.data;
        } else {
        console.error(response);
        return [];
        }

    } catch (error) {
        console.log(error);
        if (error.response && error.response.status === 401) {
        signOutUser();
        }
    }
};